import React, { useEffect, useState } from 'react';
import { useLocationSearchParam } from 'hooks/useLocation';
import { navigate } from '@reach/router';

const UserManagement = () => {
  const mode = useLocationSearchParam('mode');
  const oobCode = useLocationSearchParam('oobCode');
  const [invalidLink, setInvalidLink] = useState(false);

  useEffect(() => {
    const pageEffect = () => {
      if (mode === 'resetPassword') {
        navigate(`/reset-password/?code=${oobCode}`);
      } else if (mode === 'verifyEmail') {
        navigate(`/verify-email/?code=${oobCode}`);
      } else {
        setInvalidLink(true);
      }
    };
    pageEffect();
  }, [mode, oobCode]);

  return (
    <>
      {invalidLink && (
        <div className='change-password'>
          <div className='container'>
            <div className='change-password__success-wrap'>
              <h3 className='change-password__success-txt pb-2'>Invalid Link!</h3>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default UserManagement;
